<template>
  <span :class="cn(['', `--${isActive ? 'active' : 'inactive'}`])">
    <button @click="onClick" :class="cn('title')">
      {{ link.title }}
    </button>
    <TransitionHeight>
      <ShopifyLinks v-if="isActive" :class="cn('links')" :links="link.links" />
    </TransitionHeight>
  </span>
</template>

<script lang="ts" setup>
import { computed, onMounted } from 'vue'
import { bem } from '../../../utils/classnames'
import { LiquidLink } from '../../../types/liquid'
import TransitionHeight from '../../transition/TransitionHeight.vue'
import ShopifyLinks from './ShopifyLinks.vue'
import { useDropdownInject } from '../../../context/useDropdownContext'
import { useIsDesktop } from '../../../composables/useIsDesktop'

const cn = bem('shopify-link-dropdown')
const { current, set, isTopLevelOpen, openTopLevelOnly /* , clearTopLevel */ } = useDropdownInject()
const { isDesktop } = useIsDesktop('(min-width: 1024px)')

const props = withDefaults(
  defineProps<{
    link: LiquidLink
    depth: number
    index?: number
  }>(),
  { depth: 0, index: 0 }
)

/* --- Open on initial render if this branch (or any child) is active --- */
onMounted(() => {
  const isActiveBranch = !!(props.link.active || props.link.child_active)
  if (!isActiveBranch) return

  const isTopLevel = props.depth === 0
  if (isTopLevel && isDesktop.value) {
    // 🔴 OLD LOGIC (dual-open Jewelry + Ceremony)
    // if (props.index === 0 || props.index === 1) {
    //   openTopLevelOnly([0, 1])
    // } else {
    //   openTopLevelOnly([props.index!])
    // }

    // ✅ NEW LOGIC (single open)
    openTopLevelOnly([props.index!])
  } else {
    // Mobile / nested: single-select by title
    set(props.link.title)
  }
})

/* --- Reactive active state for this dropdown --- */
const isActive = computed(() => {
  // Desktop top-level uses multi-open indices
  if (props.depth === 0 && isDesktop.value) {
    return isTopLevelOpen(props.index!)
  }
  // Others follow the single-select "current" title
  return current?.value === props.link.title
})

/* --- Toggle: never clear everything; only open what's needed --- */
const onClick = () => {
  if (props.depth === 0 && isDesktop.value) {
    // 🔴 OLD LOGIC (dual-open Jewelry + Ceremony)
    // if (props.index === 0 || props.index === 1) {
    //   openTopLevelOnly([0, 1])
    // } else {
    //   if (!isTopLevelOpen(props.index!)) openTopLevelOnly([props.index!])
    // }

    // ✅ NEW LOGIC (single open)
    if (!isTopLevelOpen(props.index!)) openTopLevelOnly([props.index!])
  } else {
    // Mobile / nested: original single-select behavior
    set(current?.value !== props.link.title ? props.link.title : '')
  }
}
</script>

<style lang="scss"></style>
